<template>
    <div class="jobDetail">
        <div class="top">
            <app-header :oneList= "oneListData"></app-header>
        </div>
        <div class="content">
            <p class="positions">您的位置： <router-link to="/index">科研人才网</router-link> > <span>{{contentTitle}}</span></p>
            <div style="background-color:#fff;margin-bottom:40px;box-shadow: 10px 10px 10px #ccc;overflow: hidden;">
                <h3 class="titles">{{contentTitle}}</h3>
                <div v-html="resData" id="contentTable" style="padding:0 40px 40px;"></div>
            </div>
        </div>
        <app-ad :fiveListData = "threeList"></app-ad>
        <app-al :fiveListData = "threeList"></app-al>
        <app-footer></app-footer>
    </div>
</template>
<script>
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header2.vue'
import AppAd from '../../components/common/addif.vue'
import AppAl from '../../components/common/addil.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
    name: 'jobDetail',
    components: { AppFooter,AppHeader, AppAd, AppAl},
    data () {
        return {
            resData:"",
            oneListData:{},
            threeList:"",
        }
    },
    created:function () {
        this.search();
	},
    methods:{
        search(){  // 搜索
            let _self = this;
            postWithJson('/front/foot/list',{}).then(
                function(response) {
                    if(response.data.status){
                        if(response.data.data){
                            _self.resData = response.data.data[2].templateContent;
                            _self.contentTitle = response.data.data[2].templateName
                        }
                    }else{
                        console.log(response.data.message); 
                    }
                },
                function(response) {
                   _self.$message({
                        message: response.data.message,
                        type: 'error'
                    });           
                }
                
            );
            var reqData = {categoryCode:100} 
            postWithJson('front/advertises/getAdvertisesList',reqData).then(
                function(response) {
                    if(response.data.status){
                        if(response.data.data){
                            let resData = response.data.data;
                            _self.oneListData = resData[1];
                            _self.threeList = resData[5];
                        }
                    }else{
                        console.log(response.data.message); 
                    }
                },
                function(response) {
                   _self.$message({
                        message: response.data.message,
                        type: 'error'
                    });           
                }
                
            );
        },
    },
}
</script>
<style lang="less">
    #contentTable table{
        width: 880px!important;
    }
    @media all and (max-width: 768px) {
    
    #contentTable table{
        width: 100%!important;
    }
    
    
}
</style>
<style scoped = "scoped"  lang = "less">

.jobDetail{
    background:rgba(244,244,244,1);
    .top{
        width: 100%;
        background:rgba(23,135,251,1);
        .navs{
            width:1200px;
            height:50px;
            line-height: 50px;
            background:rgba(23,135,251,1);
            padding: 0 40px;
            box-sizing: border-box;
            margin: 0 auto;
            a{
                font-family:PingFangSC-Semibold;
                font-weight:600;
                color:rgba(255,255,255,1);
                box-sizing: border-box;
                font-size: 16px;
                padding: 0 4px;
                height: 40px;
                line-height: 40px;
                margin-top: 6px;
                margin-left: 25px;
            }
            a:first-child{
                margin-left: 0;

                border-bottom: 4px solid #fff;
            }
        }
    }
    .content{
        width: 980px;
        margin: 0 auto;
        .titles{
            text-align: center;
            color: #333;
            font-size: 24px;
            /* margin-top: 40px; */
            border-top: 1px solid #ddd;
            padding-top: 40px;
        }
        .positions{
            color: #333;
            font-size: 14px;
            margin: 16px 0;
            a{
                color: #333;
                font-size: 14px;
            }
        }
        .detailMsg{
            text-align: center;
            color: #666;
            font-size: 14px;
            margin:20px 0;
            i{
                font-style: normal;
                margin-right: 8px;
            }
            span{
                margin-right: 6px;
            }
        }
    }
}
.ad{
    .add{
        position: relative;
        p{
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 30px;
            line-height: 30px;
            background-color: #999;
            color: #fff;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            display: none;
        }
    }
    .add:hover p{
        display: block;
    }
    .adRight{
        position: fixed;
        top: 50%;
        right: 0;
        width: 80px;
        height: 530px;
        margin-top: -265px;
        img{
            width: 80px;
            height: 288px;
        }
        a:last-child{
            img{
                height: 220px;
                margin-top: 20px;
            }
        }
        .advisory{
            width: 60px;
            /* margin-top: 20px; */
            position: absolute;
            bottom: -20px;
            .adBlock{
                cursor: pointer;
                position: relative;
                width: 60px;
                height: 60px;
                color: #666;
                font-size: 12px;
                background-color: white;
                text-align: center;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                padding-top: 10px;
                .delivery{
                    height: 60px;
                    line-height: 60px;
                    cursor: pointer;
                    color: #fff;
                    background-color: #1787fb;
                }
                img{
                    width: 20px;
                    height: 20px;
                    margin-top: 10px;
                }
                .iconfont{
                    font-size: 24px;
                }
                div{
                    position: absolute;
                    width: 180px;
                    height: 170px;
                    right: 60px;
                    top: -60px;
                    background-color: white;
                    img{
                        width: 120px;
                        height: 120px;
                    }
                }
            }
        }
    }
}
@media all and (max-width: 768px) {
    .jobDetail{
        .content{
            width: 100%;
            img{
                display: none!important;
            }
            p,a{
                word-wrap:break-word;
            }
        }
    }
    #contentTable table{
        width: 100%!important;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/views/about/recruitment.vue